import React from 'react'

import {
    useHistory
} from "react-router-dom"

import { 
    NavListItem
} from '../../Styles/Components/NavBarStyles'

import {
    LogInButton,
    SignUpButton
} from '../../Styles/Components/CredentialActionsUtilStyles'

function CredentialActionsUtil(props){
    let history = useHistory()
    
    function loginPage(){
        history.push('/login')
    }
    function signupPage(){
        history.push('/signup')
    }
    return (
        <>
            <NavListItem>
                <LogInButton onClick={loginPage}>Log In</LogInButton>
            </NavListItem>
            <NavListItem>
                <SignUpButton onClick={signupPage}>Sign Up</SignUpButton>
            </NavListItem>
        </>
    )
}

export default CredentialActionsUtil